import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import LoadingScreen from "@/components/LoadingScreen";
import EnterPage from "@/components/EnterPage";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import PortfolioPage from "@/pages/PortfolioPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PurchaseConfirmed from "@/pages/PurchaseConfirmed";
import { Toaster } from "@/components/ui/toaster";

const Home = () => {
  return (
    <div className="bg-white min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <Pricing />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

const EnterPageWrapper = () => {
  const navigate = useNavigate();
  
  const handleEnter = () => {
    navigate('/home');
  };

  return <EnterPage onEnter={handleEnter} />;
};

const LoadingWrapper = () => {
  const navigate = useNavigate();
  
  const handleLoadingComplete = () => {
    navigate('/enter');
  };

  return <LoadingScreen onLoadingComplete={handleLoadingComplete} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoadingWrapper />} />
          <Route path="/enter" element={<EnterPageWrapper />} />
          <Route path="/home" element={<Home />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/purchaseconfirmed" element={<PurchaseConfirmed />} />
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
